import { Link } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";

// store
import useAuthStore from "store/useAuthStore";

// types
import { SamEntityItem } from "types/sam-entity-results";

const columnHelper = createColumnHelper<SamEntityItem>();

const columns = [
  columnHelper.accessor("legal_business_name", {
    id: "legal_business_name",
    header: () => "Small business name",
    cell: (props) => {
      const data = props.row.original;

      const fetchUrl = data.cage_code ? `/sam-entity/${data.uei}/${data.cage_code}` : `/sam-entity/${data.uei}`;
      return <Link to={fetchUrl}>{data.legal_business_name}</Link>;
    },
  }),
  columnHelper.accessor("uei", {
    id: "uei",
    header: () => "uei",
    cell: (props) => {
      const data = props.row.original;

      return data.uei
    },
  }),
  columnHelper.accessor("cage_code", {
    id: "cage_code",
    header: () => "CAGE Code",
    cell: (props) => {
      const data = props.row.original;

      return data.cage_code
    },
  }),
]


export {
  columns
}
